import React from "react";
import StringInput from "../formElements/StringInput";
import {useParams} from "react-router-dom";
import GenericForm from "./GenericForm";

function InstrumentStateForm(props) {
    const {id} = useParams();

    const formContent = (data, update) => (
        <StringInput name={'Nazov'} label={'Nazov'} value={data.Nazov} onChange={update} />
    );

    return (
        <GenericForm
            label="Stav Prístroja"
            labelNew="Pridať Stav Prístroja"
            baseUrl='/instrument/instrument_states/'
            id={id}
            formContent={formContent}
        />
    );
}

export default InstrumentStateForm;